import { StyleSheet } from "@react-pdf/renderer";
export const styles = StyleSheet.create({
  body: {
    paddingTop: 30,
    paddingBottom: 65,
    paddingHorizontal: 45,
  },
  title: {
    fontSize: 14,
    textAlign: "left",
    fontFamily: "Times-Bold",
    color: "#212B36",
    marginVertical: 10,
  },
  subtitle: {
    fontSize: 12,
    textAlign: "left",
    color: "#212B36",
    fontFamily: "Times-Bold",
    marginVertical: 10,
  },
  text: {
    fontSize: 12,
    textAlign: "justify",
    fontFamily: "Times-Roman",
    lineHeight: 1.5,
  },
  textBold: {
    fontSize: 12,
    textAlign: "justify",
    fontFamily: "Times-Bold",
    lineHeight: 1.5,
  },
  legend: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    maxWidth: "90%",
  },
  legendBold: {
    fontSize: 10,
    fontFamily: "Times-Bold",
  },
  logo: {
    width: "150px",
    height: "60px",
    objectFit: "cover",
  },
  logoAll: {
    width: "150px",
    height: "60px",
    objectFit: "contain",
  },
  header: {
    fontSize: 12,
    textAlign: "left",
    fontFamily: "Times-Roman",
  },
  pageNumber: {
    fontSize: 10,
    left: 0,
    textAlign: "right",
  },
  footerText: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontFamily: "Times-Roman",
    fontSize: 8,
    flexGrow: 1,
  },
  footer: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    bottom: 40,
    position: "absolute",
    width: "85%",
  },
  footerLine: {
    width: "100%",
    height: "1px",
    marginVertical: "5px",
  },
  //excluir line se nao funcionar
  line: {
    lineWidth: 1, // Largura da linha
    color: "#000000", // Cor da linha (no formato hexadecimal)
    end: { x: 500, y: 50 }, // Coordenadas do final da linha (ajuste conforme necessário)
    start: { x: 50, y: 50 },
  },
  table: {
    fontSize: 10,
    borderTop: 3,
    borderColor: "#212B36",
    display: "table",
    width: "auto",
    marginVertical: 10,
    fontFamily: "Times-Roman",
    gap: -1,
  },
  tableRow: {
    flexDirection: "row",
    gap: -1,
  },
  textBoldTable: {
    fontFamily: "Times-Bold",
  },
  textTable: {
    fontFamily: "Times-Roman",
  },
  tableCell: {
    width: "25%",
    borderWidth: 0.5,
    paddingVertical: 10,
    paddingHorizontal: 5,
    borderColor: "#d4d4dc",
    backgroundColor: "#F7F7F8",
  },
  alingRowCenter: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  iconContato: {
    filter:
      "invert(21%) sepia(12%) saturate(7089%) hue-rotate(246deg) brightness(98%) contrast(95%)",
    height: "16px",
    width: "17px",
    marginRight: "5px",
    marginTop: "4px",
    objectFit: "contain",
  },
  tableDescription: {
    fontFamily: "Times-Roman",
    padding: "4px",
    fontSize: 10,
  },
  tableDescriptionHeader: {
    flexDirection: "row",
    paddingVertical: "4px",
    fontSize: 14,
    fontFamily: "Times-Bold",
    borderBottom: "1pt solid #ddd",
    flexGrow: 1,
    justifyContent: "space-between",
  },
  tableDescriptionRow: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "1pt solid #ddd",
    fontSize: 10,
    padding: 4,
    flexGrow: 1,
    justifyContent: "space-between",
  },
  tableDescriptionSum: {
    flexDirection: "row",
    paddingHorizontal: "4px",
    paddingVertical: "8px",
    fontSize: 12,
    fontFamily: "Times-Bold",
    flexGrow: 1,
    justifyContent: "space-between",
    backgroundColor: "#eaf6fb",
  },
  firsPageContainer: { display: "flex", flexDirection: "column", gap: 2 },
  stylesReportIntro: {
    viewer: { display: "flex", flexDirection: "column", gap: 1 },
    clientTitle: {
      fontSize: 14,
      textAlign: "left",
      fontFamily: "Times-Bold",
      color: "#212B36",
      marginBottom: 5,
    },
    columnView: {
      display: "flex",
      flexDirection: "column",
      width: "50%",
    },
    columnView2: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    rowView: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      justifyContent: "center",
    },
    image: {
      height: "auto",
      width: "100%",
    },
  },
  metricsInLine: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  metricsInColumn: { display: "flex", flexDirection: "column", gap: 1 },
  metricsTable: {
    leftColumn: { flex: 1, alignItems: "flex-start" },
    middleColumn: { flex: 1, alignItems: "center" },
    rightColumn: { flex: 1, alignItems: "flex-end" },
  },
});
